import { render, staticRenderFns } from "./AfaGiudizioFinale.vue?vue&type=template&id=97552f7a"
import script from "./AfaGiudizioFinale.vue?vue&type=script&lang=js"
export * from "./AfaGiudizioFinale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports